import React, { useState, useEffect } from 'react'
import { api } from 'src/utils';
import { Button, Box, TextFieldInput, Loader } from 'src/components';
import { ProfileViewHeader } from '../index';

export default function RecoverPassword({ handleCurrentViewChange, handleSuccess }) {
    const [loading, set_loading] = useState(false);
    const timer = React.useRef();

    useEffect(() => {
        return () => {
          clearTimeout(timer.current);
        };
    }, []);

    const handleRecoverPassword = async (e) => {
        if (!loading) {
            set_loading(true);
            e.preventDefault();
            const data = e.target;
            timer.current = window.setTimeout(async () => {
                try {
                    await api.post('/auth/recover-password', { 
                        code: data.code.value,
                        password: data.password.value,
                        confirmedPassword: data.confirmPassword.value,
                    });
                    handleSuccess("Password changed successfully!");
                    handleCurrentViewChange("Login");
                } catch (err) {
                    console.log(err);
                }
                set_loading(false);
            }, 1000);
        }
    };

    return (
        <div>
            <ProfileViewHeader title="Recover Password" subtitle="Enter code and new password" handleCurrentViewChange={handleCurrentViewChange} backTo="ForgotPassword" alternateActionText="Already have an account?" alternateActionPage="Login" />

            <Box component="form" onSubmit={handleRecoverPassword} sx={{ mb: 1 }}>

                <TextFieldInput id="code" label="Recovery Code" type="text"/>
                <TextFieldInput id="password" label="New Password" type="password"/>
                <TextFieldInput id="confirmPassword" label="Confirm New Password" type="password"/>

                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="small"
                    className="submit-button button"
                    disabled={loading}>
                    Set Password
                </Button>

                {loading && (<Loader />)}

            </Box>
        </div>
    );
}
